import { Plus, FileText } from 'lucide-react'

export default function BiodataPage() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Biodata</h1>
          <p className="text-muted-foreground mt-1">
            Manage biographical information and documents
          </p>
        </div>
        <button className="btn btn-primary btn-md">
          <Plus className="mr-2 h-4 w-4" />
          Add Biodata
        </button>
      </div>

      {/* Content */}
      <div className="card">
        <div className="card-content">
          <div className="text-center py-12">
            <FileText className="mx-auto h-12 w-12 text-muted-foreground" />
            <h3 className="mt-2 text-lg font-medium text-foreground">
              Biodata Management
            </h3>
            <p className="mt-1 text-muted-foreground">
              This section will contain biodata entries and management tools.
            </p>
            <div className="mt-6">
              <button className="btn btn-primary btn-md">
                <Plus className="mr-2 h-4 w-4" />
                Create First Biodata Entry
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
